import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAustraliaPost = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 32,
		height: 32,
		rx: 16,
		fill: "#DC1928"
	}), /* @__PURE__ */ _jsxs("g", {
		transform: "translate(7 7) scale(0.596817) translate(0.740 0.580)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M0 14.498c0 6.204 3.846 11.493 9.26 13.57V.93C3.845 3.007 0 8.295 0 14.498z",
			fill: "#fff"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M14.339 0c-.397 0-.79.014-1.179.043v1.02h.073c5.465.04 9.865 4.254 9.826 9.413-.036 5.135-4.464 9.27-9.897 9.265v9.213c.387.033.781.046 1.178.046 7.916 0 14.34-6.493 14.34-14.502C28.68 6.49 22.256 0 14.34 0z",
			fill: "#fff"
		})]
	})]
});
export default SvgAustraliaPost;
